import { Formik } from 'formik';
import React from 'react';

import DropdownField from '@components/Form/DropdownField';
import { useEventTracking } from '@hooks';
import { Project } from '@interfaces/projects';
import { project_path } from '@routes';
import { ClickTarget, click } from '@tracking';

interface CategoryDropdownProps {
  categories: Pick<Project, 'title' | 'slug'>[];
  currentSlug: string;
}

const CategoryDropdown = ({ categories, currentSlug }: CategoryDropdownProps) => {
  const { trackEvent } = useEventTracking();

  const options = categories.map((category) => ({
    label: category.title,
    value: category.slug,
  }));

  const currentCategory = categories.find((c) => c.slug === currentSlug);

  return (
    <Formik
      initialValues={{
        category: { label: currentCategory?.title || 'Select Category', value: currentSlug },
      }}
      onSubmit={(values) => {
        trackEvent(click({ clickTarget: ClickTarget.DropDown }));
        if (values.category?.value) {
          window.location.href = project_path(values.category.value);
        }
      }}
    >
      {({ handleSubmit, setFieldValue }) => (
        <form onSubmit={handleSubmit}>
          <DropdownField
            className="min-w-[250px] font-suisse-intl text-form [&_div]:cursor-pointer [&_div]:text-grayscale-gray"
            name="category"
            options={options}
            placeholder="Select Category"
            isClearable={false}
            isSearchable={false}
            onChange={(option) => {
              setFieldValue('category', option);
              handleSubmit();
            }}
          />
        </form>
      )}
    </Formik>
  );
};

export default CategoryDropdown;
